




























































































import { Component, Vue } from 'vue-property-decorator';
import Bid from '@/modules/leagues/components/market/components/Bid.vue';

@Component({
    components: {
        Bid
    },
})
export default class LeagueMarketTransfers extends Vue {
    private bidOpen = false;
    private bid() {
        this.bidOpen = true;
    }
}
